import * as React from "react";
import BadgeHybrid from "./BadgeHybrid";
import type { TypeBadgeProps } from "./BadgeTypes";

/**
 * Badge component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props, a custom color, or styled() extension).
 */
const Badge = (props: TypeBadgeProps) => <BadgeHybrid {...props} />;

export default Badge;
